import { reduxForm } from 'redux-form';
import { spaPackageFormConfig } from '../shared';
import { SpaPackageExtrasConnected } from './container';
import { SpaPackageExtrasProps } from './SpaPackageExtras.types';

export const SpaPackageExtras = reduxForm<{}, SpaPackageExtrasProps>(spaPackageFormConfig)(
  SpaPackageExtrasConnected
);
